export interface SalaTeacherProfile {
  uid: string;
  displayName: string;
  email: string;
  subjectId: string;
  subjectTag: string;
  schoolName?: string;
  createdAt: number;
  updatedAt: number;
}

export function isSalaProfileComplete(profile: SalaTeacherProfile | null | undefined): boolean {
  if (!profile) return false;
  return Boolean(
    profile.displayName.trim() &&
      profile.subjectId.trim() &&
      profile.subjectTag.trim(),
  );
}
